import { Transition } from '@headlessui/react'
import { FilterTaskCard } from 'components/molecules/TaskCard/FilterTaskCard'
import { LoopkUps } from 'entities/enums/LoopkUps'
import { EmailOrAddressFormRequest } from 'entities/types/Emails'
import { CheckBoxType } from 'entities/types/Generals'
import { useActions } from 'presenter'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

export const EmailsStatusFilter = () => {
  const { getLookUps } = useActions()
  const { setValue } = useFormContext<EmailOrAddressFormRequest>()
  const [show, setShow] = useState<boolean>(false)
  const [status, setStatus] = useState<CheckBoxType[] | undefined>()

  useEffect(() => {
    const getMappedObject = async () => {
      const parsedStatus = await getLookUps(LoopkUps.PLFStatus)
      setStatus(parsedStatus?.map((item) => {
        return { checked: false, obj: item } as CheckBoxType
      }))
      setShow(true)
    }
    getMappedObject()
  }, [getLookUps])

  const onChange = (newValue: boolean, index: number) => {
    const arr = status?.map((pItem, pIdx) => {
      if (pIdx === index) {
        return { ...pItem, checked: newValue }
      }
      return pItem
    })

    setStatus(arr)
    if (arr) setValue('obj.status', arr?.filter(f => f.checked).map((item) => item.obj.itemText ?? ''))
  }

  const onSelectAll = (selectedAll: boolean) => {
    const arr = status?.map((item) => {
      return { ...item, checked: selectedAll }
    })

    setStatus(arr)
    if (arr) setValue('obj.status', arr.filter(f => f.checked).map((item) => item.obj.itemText ?? ''))
  }

  return (
    <Transition
      show={show}
      enter='transition ease-out duration-200'
      enterFrom='opacity-0 translate-y-0'
      enterTo='opacity-100 translate-y-1'
      leave='transition ease-in duration-150'
      leaveFrom='opacity-100 translate-y-1'
      leaveTo='opacity-0 translate-y-0'
    >
      <FilterTaskCard
        title={'Status'}
        maxCols={'2'}
        data={status ?? []}
        onChange={onChange}
        onSelectedAll={() => onSelectAll(true)}
        onDisSelectedAll={() => onSelectAll(false)}
      />
    </Transition>
  )
}
